import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { AgeRange, Gender, IProfileState } from ".";

export interface IProfile {
    gender: Gender,
    ageRange: AgeRange;
}

export interface IGetProfileResponse extends IProfile {};

export const getProfile = createAsyncThunk<IGetProfileResponse>(
    'getProfile',
    async () => await api.profiles.getProfile()
);

const getProfileHandler = (builder: ActionReducerMapBuilder<IProfileState>) => {
    builder
        .addCase(getProfile.pending, (state: IProfileState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getProfile.fulfilled, (state: IProfileState, action: PayloadAction<IGetProfileResponse>) => {
            state.loading = false;
            state.gender = action.payload?.gender;
            state.ageRange = action.payload?.ageRange;
            state.inited = true;
        })
        .addCase(getProfile.rejected, (state: IProfileState) => {
            state.loading = false;
            state.error = 'Unable to get profile';
        });
};

export default getProfileHandler;